module.exports = __webpack_public_path__ + "icon_chip_close.5e8e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_chip_close.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_chip_close.svg
// module chunks = main